import React from 'react';
import {Card} from '../../../../_metronic/_partials/controls';
import {InvitedUsersFilter} from '../components/InvitedUsersFilter/InvitedUsersFilter';
import {InvitedUsersTable} from '../components/InvitedUsersTable/InvitedUsersTable';
import {InvitedUsersFooter} from '../components/InvitedUsersFooter/InvitedUsersFooter';
import FooterBar from '../../_common/components/FooterBar';

export function InvitedUsersCard() {

  return (
    <Card className={'flex-fill bg-transparent shadow-none'} id={'invited-users-list-card'}>
      <InvitedUsersFilter/>
      <InvitedUsersTable/>
      <FooterBar>
        <InvitedUsersFooter/>
      </FooterBar>
    </Card>
  );
}
